/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {SpinnerService} from '../../spinner/spinner.service';
import {SpinnerContextTypeEnum} from '../../spinner/spinner-context-type.enum';

const {setTimeout, clearTimeout}: Window = window;

@Injectable({
    providedIn: 'root'
})
/**
 * <p>Service that handles the loading spinner.
 * <p>Deprecated, use {@link SpinnerService}. Delete this as soon as there is no more references to it.
 * @deprecated
 */
export class LoadingService {
    /**
     * Wait this many milliseconds after calling {@link stop}().
     * <p>
     * Useful when calling {@link start}() multiple times in quick succession and just need the last {@link stop}().
     * @deprecated
     */
    timeout = 100;

    /**
     * {@link isLoading} event emitter.
     * @deprecated
     */
    subject = new Subject<boolean>();

    /**
     * Emitted event with the value of {@link isLoading}.
     * @deprecated
     */
    onChange = this.subject.asObservable();

    /**
     * Boolean that holds information if something is loading.
     * @deprecated
     */
    private isLoading = false;

    /**
     * {@link setTimeout}() identifier.
     * @deprecated
     */
    private id: number = null;

    /**
     * @deprecated
     */
    constructor(private spinnerService: SpinnerService) {
    }

    /**
     * Notifies that something is loading.
     * @deprecated
     */
    start(): void {
        this.clearTimeout();

        this.isLoading = true;
        this.subject.next(this.isLoading);

        this.spinnerService.start(SpinnerContextTypeEnum.GLOBAL, null);
    }

    /**
     * Notifies that something stopped loading.
     * @deprecated
     */
    stop(): void {
        this.clearTimeout();

        this.id = setTimeout(() => {
            this.isLoading = false;
            this.subject.next(this.isLoading);
        }, this.timeout);

        this.spinnerService.stop(SpinnerContextTypeEnum.GLOBAL, null);
    }

    /**
     * Clears a timeout if it was created by us.
     * @deprecated
     */
    private clearTimeout(): void {
        if (this.id !== null) {
            clearTimeout(this.id);
            this.id = null;
        }
    }
}
